import { render, staticRenderFns } from "./GodImage.vue?vue&type=template&id=412cb2ce&scoped=true"
import script from "./GodImage.vue?vue&type=script&lang=js"
export * from "./GodImage.vue?vue&type=script&lang=js"
import style0 from "./GodImage.vue?vue&type=style&index=0&id=412cb2ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412cb2ce",
  null
  
)

export default component.exports